import { autobind } from 'frontools/decorators/Autobind';
import AbstractDispatcher from 'frontools/abstract/AbstractDispatcher';

declare var Vimeo;

export class Video extends AbstractDispatcher{

    public static START            : string                        = 'start';

    private _videoEl    : any;
    private _poster     : HTMLImageElement;

    constructor(private _id: string, private _targetVideo: HTMLElement, private _elPlaceHolder: HTMLElement){
        super();

        TweenMax.to(this._targetVideo, 0.2, {opacity: 0,
            onComplete: () => {
                this._openVideo();
            }
         })
    }

    private _openVideo(){
        let imgWidth : number = this._targetVideo.offsetWidth;
        let imgHeight : number = (this._targetVideo.parentNode as HTMLElement).offsetHeight;

        TweenMax.set(this._targetVideo, {height: imgHeight});
        // console.log(imgHeight)

        var options = {
            id: this._id,   
            color: 'FFFFFF',
            height: imgHeight,
            width:  imgWidth,
            autoplay:true,
        };
        

        this._videoEl = new Vimeo.Player(this._targetVideo, options);

        this._removePoster();

        // setTimeout(() => {
            this._videoEl.ready().then(function() {
                // this._videoEl.play();
                TweenMax.to(this._targetVideo, 0.2, {opacity: 1})
                TweenMax.set(this._targetVideo, {height: "auto"});
            }.bind(this))
        // }, 1000)
        // Not working on ios -->
        // this._videoEl.on('play', () => {
            // TweenMax.to(this._targetVideo, 0.2, {opacity: 1})
            // TweenMax.set(this._targetVideo, {height: "auto"});
        // })
    }

    private _removePoster(){
        if (this._elPlaceHolder) this._elPlaceHolder.remove();
    }

    public get id() : string {
        return this._id;
    }
}


